import { render } from "./StatsHandicap.vue?vue&type=template&id=4e63f011&scoped=true"
import script from "./StatsHandicap.vue?vue&type=script&lang=js"
export * from "./StatsHandicap.vue?vue&type=script&lang=js"

import "./StatsHandicap.vue?vue&type=style&index=0&id=4e63f011&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e63f011"]])

export default __exports__